import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../../partials/Container'
import GroupForm from '../../partials/GroupForm'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class CommunityGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        name: ''
      }
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const groupId = this.props.match.params.groupId
    const _searchApplications = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _searchApplications()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : [])
        ])
          .then(() => {
            const group = (this.props.Community.groups[comId] || [])
              .slice()
              .find(g => g.id === groupId)
            this.setState({
              ...this.state,
              editor: {
                ...this.state.editor,
                name: group.name
              }
            })
          })
          .catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _searchApplications()
  }

  onPermClick (e) {
    const name = e.currentTarget.dataset.name
    const comId = this.props.match.params.comId
    const groupId = this.props.match.params.groupId
    const group = (this.props.Community.groups[comId] || [])
      .slice()
      .find(g => g.id === groupId)

    return this.props.Community.patchCommunityGroup(
      comId,
      group.id,
      'permissions',
      {
        ...(group.permissions[name]
          ? Object.keys(group.permissions).reduce(
              (obj, p) => ({
                ...obj,
                ...(p !== name ? { [p]: true } : {})
              }),
              {}
            )
          : {
            ...group.permissions,
            [name]: true
          })
      }
    )
  }

  onNameInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.group,
        name: e.target.value
      }
    })
  }

  onNameInputBlur (e) {
    const comId = this.props.match.params.comId
    const groupId = this.props.match.params.groupId
    const group = (this.props.Community.groups[comId] || [])
      .slice()
      .find(g => g.id === groupId)

    return this.props.Community.patchCommunityGroup(
      comId,
      group.id,
      'name',
      this.state.editor.name
    )
  }

  goBack (e) {
    e.preventDefault()
    return this.props.history.push(
      this.props.match.url.replace(`/${this.props.match.params.groupId}`, '')
    )
  }

  render () {
    const comId = this.props.match.params.comId
    const groupId = this.props.match.params.groupId
    const group = (this.props.Community.groups[comId] || [])
      .slice()
      .find(g => g.id === groupId)

    if (!group) {
      return null
    }

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>Edit Group</h2>
              </Col>
              <Col>
                <Row>
                  <Col />
                  <Col>
                    <span
                      onClick={this.goBack.bind(this)}
                      className={css(style.buttons.button, style.buttons.red)}
                    >
                      Go Back
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <GroupForm
              theme={THEME_LIST[this.props.Config.theme]}
              group={group || {}}
              editor={this.state.editor}
              onPermClick={this.onPermClick.bind(this)}
              onNameInputBlur={this.onNameInputBlur.bind(this)}
              onNameInputChange={this.onNameInputChange.bind(this)}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CommunityGroup



// WEBPACK FOOTER //
// ./src/components/Community/Group/Edit/index.js